export default __webpack_public_path__ + "static/media/Scholar's Band of the Crescent.cac8eb31.jpg";